// TODO: Update this URL when the email service is deployed
export const EMAIL_API_URL = 'https://nustlife-email-service.onrender.com/api/email';
